import { useState } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { renderActiveShape } from "../../utils/pieChartUtils";

export const AppPieChart = ({
  data,
  colors,
  innerRadius = 60,
  outerRadius = 80,
  startAngle,
  endAngle,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  const allZero = data.every((item) => item.value === 0);
  const dataToRender = allZero
    ? [{ name: "No Data", value: 1 }]
    : data.map((item) =>
        item.value === 0 ? { ...item, value: 0.0001 } : item
      );
  const COLORS = allZero
    ? ["#e0e0e0"] // full grey
    : colors;

  return (
    <ResponsiveContainer width="90%" height="90%">
      <PieChart width={400} height={400}>
        <Pie
          activeIndex={activeIndex}
          activeShape={(props) => renderActiveShape(props, allZero)}
          data={dataToRender}
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          dataKey="value"
          onMouseEnter={onPieEnter}
          startAngle={startAngle}
          endAngle={endAngle}
        >
          {dataToRender.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLORS[index % COLORS.length]}
              stroke="#1D2637" // Border color set to red
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
